const AnimatedStroke = {

	init: function (svgElement) {
		const elements = svgElement.querySelectorAll('.animated-stroke');
		elements.forEach(function (element) {
			this.setStrokeLength(element);
		}.bind(this));

		const observer = new IntersectionObserver(function (entries) {
			for (let i = 0; i < entries.length; i++) {
				if (entries[i].isIntersecting) {
					observer.unobserve(entries[i].target);
					entries[i].target.classList.add('animate');
					for (let j = 0; j < elements.length; j++) {
						elements[j].classList.add('animate');
					}
				}
			}
		}.bind(this));
		observer.observe(svgElement);
	},

	setStrokeLength: function (element) {
		const strokeLength = element.getTotalLength();
		element.setAttribute('stroke-dasharray', strokeLength);
		element.setAttribute('stroke-dashoffset', strokeLength);
	},

};

export default AnimatedStroke;
